import { render, staticRenderFns } from "./03_2_RepresentativeBlockForm.vue?vue&type=template&id=92d7648e&scoped=true&"
import script from "./03_2_RepresentativeBlockForm.vue?vue&type=script&lang=js&"
export * from "./03_2_RepresentativeBlockForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d7648e",
  null
  
)

export default component.exports